import { Col, Container, Row } from 'react-bootstrap';
import { CoachMiniCalendarBlock } from '../blocks/coach-mini-calendar';
import { AthleteMiniCalendarBlock } from '../blocks/athlete-mini-calendar';
import { CompetitionsBlock } from '../blocks/competitions';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../App';
import { t } from 'i18next';
import { AthletesMini } from '../blocks/athletes-mini';
import { TeamsMini } from '../blocks/teams-mini';
import { CompetitionsCalendarBlock } from '../blocks/competitions-calendar';
import { RankingsMini } from '../blocks/rankings-mini';
import { StatisticsMini } from '../blocks/statistics-mini';
import { AthletePerformanceBlock } from '../blocks/athlete-performance';
import { AthletesTeamsMini } from '../blocks/athletes-teams-mini';
import { EventsBlock } from '../blocks/events';
import { AthleteActivitiesBlock } from '../blocks/athlete-activities';
import { getUserWearables } from '../../services/user';
import { emptyUserWearables, UserWearables } from '../../interfaces/user';

export default function Dashboard() {
    const { userProfile } = useContext(UserContext);
    const is_athlete = (userProfile.role.filter((r: any) => r.id == 'padeltech_athlete').length > 0);

    const [userWearables, setUserWearables] = useState<UserWearables>(emptyUserWearables);

    useEffect(() => {
        getUserWearables()
        .then(response => {
            setUserWearables(response.data);
        })
        .catch(error => {
            console.log(error);
        });
    }, []);

    return (
        <div className="dashboard-container">
            <Container>
                <Row>
                    <Col xs={12}>
                        <h1>
                            <span className="normal">{ t("welcome") }</span> { userProfile.name }
                        </h1>
                    </Col>
                </Row>
                { userProfile.role.filter((r: any) => r.id == 'padeltech_administrator').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <TeamsMini />
                            <RankingsMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <AthletesMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <CompetitionsCalendarBlock />
                            <EventsBlock />
                        </Col>
                    </Row>
                }
                { userProfile.role.filter((r: any) => r.id == 'padeltech_manager').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <TeamsMini />
                            <RankingsMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <AthletesMini />
                        </Col>
                        <Col xs={12} lg={4}>
                            <CompetitionsCalendarBlock />
                            <EventsBlock />
                        </Col>
                    </Row>
                }
                { userProfile.role.filter((r: any) => r.id == 'padeltech_coach').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <CoachMiniCalendarBlock />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <AthletesMini />
                            <RankingsMini />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <CompetitionsCalendarBlock />
                            <EventsBlock />
                        </Col>
                    </Row>
                }
                { userProfile.role.filter((r: any) => r.id == 'padeltech_athlete').length > 0 &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <AthleteMiniCalendarBlock />
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            { is_athlete && userProfile.reference_id != 0 && <AthletePerformanceBlock athlete_id={ userProfile.reference_id } /> }
                            { is_athlete && userWearables.garmin_user_id != '' && <AthleteActivitiesBlock userId={ userWearables.garmin_user_id } /> }
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <CompetitionsCalendarBlock />
                            <EventsBlock />
                        </Col>
                    </Row>
                }
            </Container>
        </div>
    );
}
